type PassportVerifyTrackAttrs = {
    result: 0 | 1;
    error_msg?: string;
    error_code?: string | number;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

export const buildPassportVerifySuccessTrackAttrs =
    (): PassportVerifyTrackAttrs => ({
        result: 1
    });

/**
 * 保证 Promise.reject 的 reason 可被 error-base 解析出 message，
 * 避免空 reject / undefined 回落成 "unknown error"。
 */
export const ensureRejectReason = (
    error: unknown,
    fallbackMessage: string
): unknown => {
    if (error === undefined || error === null || error === '') {
        return fallbackMessage;
    }

    return error;
};

export const buildPassportVerifyFailTrackAttrs = (
    error: unknown
): PassportVerifyTrackAttrs => {
    const defaultErrorMsg = 'checkPhone fail';
    const defaultErrorCode = 'checkPhone_fail';
    const normalizedError = isRecord(error) ? error : null;
    const errorMsg =
        (normalizedError && typeof normalizedError.message === 'string'
            ? normalizedError.message
            : null) ||
        (typeof error === 'string' ? error : null) ||
        defaultErrorMsg;
    const errorCode =
        normalizedError &&
        (typeof normalizedError.code === 'string' ||
            typeof normalizedError.code === 'number')
            ? normalizedError.code
            : defaultErrorCode;

    return {
        result: 0,
        error_msg: errorMsg,
        error_code: errorCode
    };
};
